<script setup lang="ts">
import Sidebar from '@/components/Sidebar.vue';
import { Block, LayoutGap } from '@dabble/quillui';
</script>

<template>
  <LayoutGap direction="row" align="left" vertical-align="stretch" fill size="none" class="account-layout">
    <Sidebar />
    <Block variant="canvas" padding="xlarge" class="account-layout__panel" border-radius="large">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </Block>
  </LayoutGap>
</template>

<style lang="scss" scoped>
.account-layout {
  height: 100vh;
  background-color: theme('color-bg-app-overlay');
}

.account-layout__main {
  min-width: 0;
  min-height: 0;
  flex: 1;
  align-self: stretch;
  display: flex;
  flex-direction: column;
}

.account-layout__panel {
  margin: space('small');
  overflow: auto;
}
</style>
